import React from 'react';

const LatestShipmentsTable = ({ shipments, onShipmentClick }) => {
  const statusLabels = {
    pending: 'En préparation',
    in_transit: 'En transit',
    customs: 'En douane',
    out_for_delivery: 'En livraison',
    delivered: 'Livré',
    exception: 'Problème'
  };

  const statusColors = {
    pending: 'bg-blue-100 text-blue-800',
    in_transit: 'bg-purple-100 text-purple-800',
    customs: 'bg-yellow-100 text-yellow-800',
    out_for_delivery: 'bg-indigo-100 text-indigo-800',
    delivered: 'bg-green-100 text-green-800',
    exception: 'bg-red-100 text-red-800'
  };

  const paymentStatusLabels = {
    non_paye: 'Non payé',
    partiel: 'Partiel',
    paye: 'Payé'
  };

  const paymentStatusColors = {
    non_paye: 'bg-red-100 text-red-800',
    partiel: 'bg-orange-100 text-orange-800',
    paye: 'bg-green-100 text-green-800'
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <h2 className="text-xl font-semibold text-gray-900 mb-4">Derniers envois</h2>
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Référence
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Date
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Expéditeur
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Destinataire
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Statut
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Paiement
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Action
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {shipments?.map((shipment) => (
              <tr key={shipment?.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm font-medium text-gray-900">
                    {shipment?.reference}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                  {new Date(shipment?.createdAt)?.toLocaleDateString('fr-FR')}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {shipment?.senderName}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {shipment?.receiverName}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${statusColors?.[shipment?.status]}`}>
                    {statusLabels?.[shipment?.status] || shipment?.status}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${paymentStatusColors?.[shipment?.paymentStatus]}`}>
                    {paymentStatusLabels?.[shipment?.paymentStatus] || shipment?.paymentStatus}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm">
                  <button
                    onClick={() => onShipmentClick?.(shipment?.id)}
                    className="text-green-600 hover:text-green-900 font-medium"
                  >
                    Voir
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LatestShipmentsTable;